@if ({ sidenavCollapsed: (drawerService.sidenavCollapsed$ | async) }; as vm) {
  <mat-nav-list class="sidebar" role="list">
    <div
      [ngClass]="{
        company: true,
        'company-collapsed': vm.sidenavCollapsed
      }">
      <div
        (click)="
          drawerService.toggleSidenav();
          linksExpanded = false;
          applicationManagementExpanded = false
        "
        [ngClass]="!vm.sidenavCollapsed ? 'nav-arrow' : 'nav-menu'">
        @if (!vm.sidenavCollapsed) {
          <mat-icon
            aria-hidden="false"
            aria-label="Arr

        ow left"
            fontIcon="arrow_backward"></mat-icon>
        }
        @if (drawerService.sidenavCollapsed$ | async) {
          <mat-icon
            aria-hidden="false"
            aria-label="Menu icon"
            fontIcon="menu"
            class="menu-icon"></mat-icon>
        }
      </div>
      @if (!vm.sidenavCollapsed) {
        <div class="company-wrapper">
          @if ((tenantService.changingTenant$ | async) === false) {
            <div class="company-logo">
              <img
                src="assets/icons/R360-icon.svg"
                i18n-alt
                alt="Company Logo" />
            </div>
          }
          @if ((tenantService.changingTenant$ | async) === false) {
            <div>
              @if (name) {
                <h4 class="company-title">
                  {{ name }}
                </h4>
              } @else {
                <h4 class="company-title">
                  {{ tenantService.initialTenantName }}
                </h4>
              }
            </div>
          } @else {
            <img class="company-loader" src="assets/img/bar-loader.gif" />
          }
        </div>
      }
    </div>
    <div
      #hierarchyPopoverButton
      [ngClass]="{ 'nav-list': vm.sidenavCollapsed }">
      <button
        class="hierarchy-popover-button"
        (click)="openMenu()"
        #menuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="menu"
        i18n-matTooltip
        matTooltip="Hierarchy"
        matTooltipClass="customToolTip menuTooltip"
        [matTooltipDisabled]="!vm.sidenavCollapsed"
        [ngClass]="{
          'hierarchy-popover-button': true,
          'hierarchy-popover-button-collapsed': vm.sidenavCollapsed
        }">
        <div class="title">
          <img [src]="'Hierarchy' | icon: 'Icon'" class="icon" />
          @if (!vm.sidenavCollapsed) {
            <span class="uppercase"
              ><ng-container i18n>Hierarchy</ng-container></span
            >
          }
        </div>
        @if (!vm.sidenavCollapsed) {
          <img
            src="assets/icons/WHT_Arrow_Icon.svg"
            alt="arrow right icon"
            i18n-placeholder />
        }
      </button>
      <mat-menu
        #menu="matMenu"
        [class]="
          vm.sidenavCollapsed
            ? 'hierarchy-popover-menu-collapsed'
            : 'hierarchy-popover-menu'
        ">
        <div class="callout">
          <div class="triangle"></div>
          <div class="inner-triangle"></div>
        </div>
        <div class="menu-wrapper" (click)="$event.stopPropagation()">
          <hierarchy-popover
            (closeMenu)="closeMenu($event)"
            [hierarchyTopCoordinate]="
              hierarchyTopCoordinate
            "></hierarchy-popover>
        </div>
      </mat-menu>
      @for (item of menuItems; track item.name) {
        <a
          [routerLink]="item.target"
          [matTooltip]="item.name"
          matTooltipClass="customToolTip menuTooltip"
          [matTooltipDisabled]="!vm.sidenavCollapsed">
          @if (!item.hide) {
            <mat-list-item
              [class.active]="item.target === (currentPage$ | async)">
              <div
                [ngClass]="{
                  'menu-item': true,
                  'menu-item-collapsed': vm.sidenavCollapsed
                }">
                <img [src]="item.icon | icon: 'Icon'" class="sidebar-icon" />
                @if (!vm.sidenavCollapsed) {
                  <p>
                    {{ item.name }}
                  </p>
                }
              </div>
            </mat-list-item>
          }
        </a>
      }
    </div>
    @if (
      userInfoService.hasPermission('platformSupport') &&
      (flagService.flags$ | async)?.['application_management']
    ) {
      <a
        i18n-matTooltip
        matTooltip="Application Management"
        matTooltipClass="customToolTip menuTooltip"
        [matTooltipDisabled]="!vm.sidenavCollapsed">
        <mat-list-item
          (click)="
            vm.sidenavCollapsed && drawerService.toggleSidenav();
            applicationManagementExpanded = !applicationManagementExpanded
          ">
          <div
            [ngClass]="{
              'menu-item': true,
              'menu-item-collapsed': vm.sidenavCollapsed
            }">
            <img [src]="'User' | icon: 'Icon'" class="sidebar-icon" />
            @if (!vm.sidenavCollapsed) {
              <p class="application-management-header">
                <span
                  [truncateHover]="'Application Management' | sidebarTranslate"
                  class="application-management truncate">
                  <ng-container i18n>Application Management</ng-container>
                </span>
                @if (!applicationManagementExpanded) {
                  <i class="pi pi-angle-up caret-icon"></i>
                }
                @if (applicationManagementExpanded) {
                  <i class="pi pi-angle-down caret-icon"></i>
                }
              </p>
            }
          </div>
        </mat-list-item>
      </a>
    }
    @if (!vm.sidenavCollapsed && applicationManagementExpanded) {
      <a
        (click)="openAddOrganizationModal()"
        i18n-matTooltip
        matTooltip="Add Organization"
        matTooltipClass="customToolTip menuTooltip"
        [matTooltipDisabled]="!vm.sidenavCollapsed">
        <mat-list-item>
          <div class="menu-item links">
            @if (!vm.sidenavCollapsed) {
              <p>
                <ng-container i18n>Add Organization</ng-container>
              </p>
            }
          </div>
        </mat-list-item>
      </a>
      <a
        (click)="openRegisterGatewayModal()"
        matTooltip="Register Gateway"
        matTooltipClass="customToolTip menuTooltip"
        [matTooltipDisabled]="!vm.sidenavCollapsed">
        <mat-list-item>
          <div class="menu-item links">
            @if (!vm.sidenavCollapsed) {
              <p>
                <ng-container i18n>Register Gateway</ng-container>
              </p>
            }
          </div>
        </mat-list-item>
      </a>
    }
    <a
      [routerLink]="'contacts'"
      i18n-matTooltip
      matTooltip="Contacts"
      matTooltipClass="customToolTip menuTooltip"
      [matTooltipDisabled]="!vm.sidenavCollapsed">
      <mat-list-item [class.active]="'contacts' === (currentPage$ | async)">
        <div
          [ngClass]="{
            'menu-item': true,
            'menu-item-collapsed': vm.sidenavCollapsed
          }">
          <img [src]="'Phone' | icon: 'Icon'" class="sidebar-icon" />
          @if (!vm.sidenavCollapsed) {
            <p>
              <ng-container i18n>Contacts</ng-container>
            </p>
          }
        </div>
      </mat-list-item>
    </a>
    <a
      i18n-matTooltip
      matTooltip="Links"
      matTooltipClass="customToolTip menuTooltip"
      [matTooltipDisabled]="!vm.sidenavCollapsed">
      <mat-list-item
        (click)="
          vm.sidenavCollapsed && drawerService.toggleSidenav();
          linksExpanded = !linksExpanded
        ">
        <div
          [ngClass]="{
            'menu-item': true,
            'menu-item-collapsed': vm.sidenavCollapsed
          }">
          <img [src]="'Knowledgebase' | icon: 'Icon'" class="sidebar-icon" />
          @if (!vm.sidenavCollapsed) {
            <p class="links-header">
              <ng-container i18n>Links</ng-container>
              @if (!linksExpanded) {
                <i class="pi pi-angle-up caret-icon"></i>
              }
              @if (linksExpanded) {
                <i class="pi pi-angle-down caret-icon"></i>
              }
            </p>
          }
        </div>
      </mat-list-item>
    </a>
    @if (!vm.sidenavCollapsed && linksExpanded) {
      <a
        target="_blank"
        rel="noopener noreferrer"
        [href]="appConfigService.sdPlusSupportLink"
        i18n-matTooltip
        matTooltip="Support"
        matTooltipClass="customToolTip menuTooltip"
        [matTooltipDisabled]="!vm.sidenavCollapsed">
        <mat-list-item>
          <div class="menu-item links">
            @if (!vm.sidenavCollapsed) {
              <p>
                <ng-container i18n>Support</ng-container>
              </p>
            }
          </div>
        </mat-list-item>
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://status.app.advancedtech.com/"
        i18n-matTooltip
        matTooltip="ATS Systems Status"
        matTooltipClass="customToolTip menuTooltip"
        [matTooltipDisabled]="!vm.sidenavCollapsed">
        <mat-list-item>
          <div class="menu-item links">
            @if (!vm.sidenavCollapsed) {
              <p>
                <ng-container i18n>ATS Systems Status</ng-container>
              </p>
            }
          </div>
        </mat-list-item>
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://knowledge.iiot.advancedtech.com/"
        i18n-matTooltip
        matTooltip="Knowledgebase"
        matTooltipClass="customToolTip menuTooltip"
        [matTooltipDisabled]="!vm.sidenavCollapsed">
        <mat-list-item>
          <div class="menu-item links">
            @if (!vm.sidenavCollapsed) {
              <p>
                <ng-container i18n>Knowledgebase</ng-container>
              </p>
            }
          </div>
        </mat-list-item>
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://uservoice.advancedtech.com/forums/955841-r360"
        matTooltip="UserVoice"
        matTooltipClass="customToolTip menuTooltip"
        [matTooltipDisabled]="!vm.sidenavCollapsed">
        <mat-list-item>
          <div class="menu-item links">
            @if (!vm.sidenavCollapsed) {
              <p>
                <ng-container i18n>UserVoice</ng-container>
              </p>
            }
          </div>
        </mat-list-item>
      </a>
    }
  </mat-nav-list>
}
